import React, { useState } from 'react';

import { useGetEvents } from '@vlabs/api/artemy/client';
import type { GetEventsParams } from '@vlabs/api/artemy/model';
import { artemyEventApi, EventApiProvider } from '@vlabs/monokit/entities/events/api';
import {
  EventListFiltersProvider,
  useEventListFilters,
} from '@vlabs/monokit/entities/events/filters';
import { Page } from '@vlabs/monokit/shared/ui/page';

import { EventRoll } from './event-roll/EventRoll.js';
import type { SidebarName } from './event-roll/EventRoll.js';
import { WORKSPACE_DEFAULT_FILTERS } from './filters/constants';
import { SelectedEventView } from './selected-event/SelectedEventView';
import st from './Workspace.module.sass';
import { WorkspaceEventProvider } from './WorkspaceEventContext';

function WorkspaceContent(): React.JSX.Element {
  const [activeSidebar, setActiveSidebar] = useState<SidebarName | null>(null);
  const { filters } = useEventListFilters();

  const { data: eventsData } = useGetEvents(filters as GetEventsParams);
  const events = eventsData?.events ?? [];
  console.log('🚀 ~ WorkspaceContent ~ events:', events);

  const toggleSidebar = (name: SidebarName) => {
    setActiveSidebar((prev) => (prev === name ? null : name));
  };

  return (
    <WorkspaceEventProvider>
      <Page className={st.Root}>
        <EventRoll
          activeSidebar={activeSidebar}
          events={events}
          onToggleSidebar={toggleSidebar}
        />

        <SelectedEventView
          activeSidebar={activeSidebar}
          onToggleSidebar={toggleSidebar}
        />
      </Page>
    </WorkspaceEventProvider>
  );
}

export function Workspace(): React.JSX.Element {
  return (
    <EventApiProvider api={artemyEventApi}>
      <EventListFiltersProvider initialData={WORKSPACE_DEFAULT_FILTERS}>
        <WorkspaceContent />
      </EventListFiltersProvider>
    </EventApiProvider>
  );
}
